import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
export default function extractCurrencyCode(c) {
  return typeof c === 'string' ? c.split('-')[0] : c;
}